import { useInstructorsData } from '@features/instructors/contexts/data/useInstructorsData';
import { useInstructorsFilter } from '@features/instructors/contexts/filter/useInstructorsFilter';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import { InstructorsList } from './list/InstructorsList';

const InstructorsContent = React.memo((): React.ReactElement => {
  const { instructors } = useInstructorsData();
  const { data, isLoading, isFetching, isError } = instructors;
  const { isFiltersApplied, isSearchApplied } = useInstructorsFilter();

  if (isLoading || isFetching) {
    return <ContentLoader />;
  }

  if (isError) {
    return <InlineFeedback type="data-error" />;
  }

  if (data.elements.length === 0) {
    if (isFiltersApplied || isSearchApplied) {
      return <InlineFeedback type="no-search-results" />;
    }
    return <InlineFeedback type="so-empty" />;
  }

  return <InstructorsList />;
});

InstructorsContent.displayName = 'InstructorsContent';

export { InstructorsContent };
